
const digest = 'e46ae69b73679dc202b8305b66f807a1052da37e7f843b2610abf91f81bdec6c';
const classes = {"wrapper":"_wrapper_5ox4j_1"};
const css = `._wrapper_5ox4j_1 {
  height: 25px;
  width: 25px;
}
._wrapper_5ox4j_1:hover {
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  